export function limitObjectsPerStep(array) {
  const stepCounts = new Map();
  return array.filter(({ step, layer }) => {
    const count = stepCounts.get(step) ?? 0;
    stepCounts.set(step, count + 1);
    return step === 11 && layer ? count < 11 : count < 10;
  });
}
